<script>
  import { _ } from 'svelte-i18n';
  import { createEventDispatcher, tick } from 'svelte';

  const dispatch = createEventDispatcher();

  export let description = "";
  
  let isEditing = false;
  let isHovering = false;
  let originalContent = description; // Store original content when entering edit mode

  function startEditing() {
    isEditing = true;
    // Store original content before editing starts
    originalContent = description;
  }

  function normalizeText(text) {
    // Normalize whitespace while preserving line structure
    return text.trim();
  }

  function handleBlur() {
    isEditing = false;
    // Compare normalized descriptions
    if (normalizeText(description) !== normalizeText(originalContent)) {
      dispatch('descriptionChange', description);
      console.log('Description changed:', description);
    } else {
      description = originalContent;
    }
  }

  function handleKeyDown(event) {
    // Done on Enter key (without shift)
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleBlur();
    }
  }
</script>

<div class="StorefrontDescription" class:isEditing={isEditing}>
  {#if isEditing}
    <textarea
      bind:value={description}
      on:blur={handleBlur}
      on:keydown={handleKeyDown}
      on:mouseenter={() => isHovering = true}
      on:mouseleave={() => isHovering = false}
      class="isEditing"
    ></textarea>
    <small class="instructions">press <span class="key">SHIFT + ENTER</span> for new line and <span class="key">ENTER</span> when done</small>
  {:else}
    <p
      class:hovering={isHovering}
      on:mouseenter={() => isHovering = true}
      on:mouseleave={() => isHovering = false}
      on:click={startEditing}
    >
      {description}
    </p>
    <svg class="edit-icon"><use xlink:href="#icon-edit"/></svg>
  {/if}
</div>

<style>
  .StorefrontDescription {
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-bottom: 2rem;
    font-size: 1.6rem;
  }
  .StorefrontDescription:not(.isEditing) {
    flex-direction: row;
  }

  textarea,
  p {
    min-width: 46rem;
    max-width: 80%;
    padding: 1rem 2.5rem;
    line-height: 2rem;
    white-space: pre-wrap;
    text-align: center;
    color: var(--c-text);
    border: 1px solid transparent;
    transition-property: border-color, background-color;
    transition-duration: var(--transition-duration);
    transition-timing-function: var(--transition-function);
  }
  textarea.isEditing {
    padding: 1rem 1.5rem;
    min-height: 4rem;
    background-color: var(--c-content-bg);
    border: 1px solid var(--c-accent);
    outline: none;
  }
  p.hovering {
    background-color: var(--c-nav-bg);
    border-color: var(--c-pill-bg-hover);
    cursor: text;
  }
  p.hovering + .edit-icon {
    stroke: var(--c-accent);
  }
  .instructions {
    margin-bottom: -1.3rem;
  }
  .instructions .key {
    font-family: var(--PensumSans-Bold);
    font-size: 1.3rem;
  }

  .edit-icon {
    width: 3.5rem;
    height: 3.5rem;
    margin: -1rem 0;
    margin-left: -3.5rem;
    vertical-align: middle;
    stroke: var(--c-text);
    transition: stroke var(--transition-props);
    pointer-events: none;
  }
</style>